import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export default Content;
